import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-invitations',
  templateUrl: './invitations.component.html',
  styleUrls: ['./invitations.component.scss', '../../pages-professional.component.scss']
})
export class InvitationsComponent implements OnInit {

  pages = [
    { path: '/professional/account/invitations/sent-invitations', title: 'Sent invitations', urlPath: 'sent-invitations' },
    { path: '/professional/account/invitations/received-invitations', title: 'Received invitations', urlPath: 'received-invitations' },
    //  { path: '/pages/account/settings/properties', title: 'Properties', urlPath: 'properties' }
  ]
  pageTitle = "Invitations"
  currentPage;
  private currentPageAnnouncer = new Subject<any>();
  currentPage$ = this.currentPageAnnouncer.asObservable()
  constructor() { }

  ngOnInit() {
  }
  public onRouterOutletActivate(event: any) {
    if (event.pageTitle) {
      this.currentPageAnnouncer.next(event.pageTitle)
      this.currentPage = event.pageTitle;
    }
    // console.log("EVENT",event);
  }
  isCurrentPage(page) {
    return page.title == this.currentPage;
  }

  getOtherPages() {
    return this.pages.filter(p => p.title != this.currentPage)
  
}
}
